import api from "../services/api";
import { getBackendUrl } from "../config";

// ===================================================================
// Sons do sistema. Todos sao SINTETIZADOS no navegador (Web Audio): nao ha
// arquivo de audio para baixar. Cada EVENTO (nova mensagem, aviso, cliente
// transferido, mensagem enviada) usa um SOM da biblioteca abaixo, com volume
// proprio. A escolha fica em Configuracoes > Sons e notificacoes e vale para
// toda a equipe (Setting "sonsNotificacao").
// ===================================================================

let audioCtx = null;

const getCtx = () => {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  // O navegador deixa o audio "suspenso" ate a pessoa clicar na pagina.
  if (audioCtx.state === "suspended") {
    try { audioCtx.resume(); } catch (e) {}
  }
  return audioCtx;
};

// Chamado no primeiro clique/tecla da pagina: sem isso o Chrome bloqueia o som.
export const destravarAudio = () => {
  try { getCtx(); } catch (e) {}
};

// Um tom com envelope (ataque rapido + decaimento). freqFim faz "deslizar".
const tom = (ctx, saida, freq, inicio, dur, opt = {}) => {
  const { tipo = "sine", vol = 0.5, ataque = 0.005, freqFim = null, sustentar = false } = opt;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = tipo;
  osc.frequency.setValueAtTime(freq, inicio);
  if (freqFim) osc.frequency.exponentialRampToValueAtTime(freqFim, inicio + dur);
  g.gain.setValueAtTime(0.0001, inicio);
  g.gain.exponentialRampToValueAtTime(vol, inicio + ataque);
  if (sustentar) g.gain.setValueAtTime(vol, inicio + dur - 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, inicio + dur);
  osc.connect(g);
  g.connect(saida);
  osc.start(inicio);
  osc.stop(inicio + dur + 0.03);
};

// Biblioteca de sons prontos. "t" = instante de inicio.
export const SONS = [
  {
    id: "bolha", nome: "Bolha", detalhe: "Dois toques suaves, estilo mensageiro",
    tocar: (c, s, t) => { tom(c, s, 600, t, 0.1, { vol: 0.35 }); tom(c, s, 800, t + 0.1, 0.15, { vol: 0.35 }); },
  },
  {
    id: "gota", nome: "Gota", detalhe: "Pingo d'água curto e discreto",
    tocar: (c, s, t) => { tom(c, s, 1400, t, 0.14, { vol: 0.45, freqFim: 420 }); tom(c, s, 1800, t + 0.16, 0.08, { vol: 0.15, freqFim: 900 }); },
  },
  {
    id: "pop", nome: "Pop", detalhe: "Estalo único bem curto",
    tocar: (c, s, t) => { tom(c, s, 400, t, 0.1, { vol: 0.3 }); },
  },
  {
    id: "ding", nome: "Ding", detalhe: "Dois tons de notificação",
    tocar: (c, s, t) => { tom(c, s, 700, t, 0.12, { tipo: "triangle", vol: 0.45 }); tom(c, s, 900, t + 0.1, 0.22, { tipo: "triangle", vol: 0.45 }); },
  },
  {
    id: "cristal", nome: "Cristal", detalhe: "Três notas agudas, brilhante",
    tocar: (c, s, t) => {
      [1318.5, 1568, 2093].forEach((f, i) => tom(c, s, f, t + i * 0.09, 0.45, { tipo: "triangle", vol: 0.3 }));
    },
  },
  {
    id: "sino", nome: "Sino", detalhe: "Badalada com eco longo",
    tocar: (c, s, t) => {
      tom(c, s, 880, t, 1.4, { vol: 0.4 });
      tom(c, s, 880 * 2.76, t, 0.8, { vol: 0.12 });
      tom(c, s, 880 * 5.4, t, 0.4, { vol: 0.06 });
    },
  },
  {
    id: "marimba", nome: "Marimba", detalhe: "Toque de madeira, alegre",
    tocar: (c, s, t) => {
      [[523.25, 0], [784, 0.13], [1046.5, 0.26]].forEach(([f, d]) => {
        tom(c, s, f, t + d, 0.22, { vol: 0.45 });
        tom(c, s, f * 4, t + d, 0.06, { vol: 0.08 });
      });
    },
  },
  {
    id: "harpa", nome: "Harpa", detalhe: "Escala rápida subindo",
    tocar: (c, s, t) => {
      [523.25, 587.33, 659.25, 783.99, 880, 1046.5].forEach((f, i) => tom(c, s, f, t + i * 0.06, 0.5, { tipo: "triangle", vol: 0.22 }));
    },
  },
  {
    id: "acorde", nome: "Acorde", detalhe: "Acorde aberto, calmo",
    tocar: (c, s, t) => {
      [392, 523.25, 659.25, 783.99].forEach((f, i) => tom(c, s, f, t + i * 0.04, 0.9, { vol: 0.18, ataque: 0.02 }));
    },
  },
  {
    id: "digital", nome: "Digital", detalhe: "Bip-bip eletrônico",
    tocar: (c, s, t) => { tom(c, s, 1500, t, 0.07, { tipo: "square", vol: 0.18, sustentar: true }); tom(c, s, 1500, t + 0.12, 0.07, { tipo: "square", vol: 0.18, sustentar: true }); },
  },
  {
    id: "alarme", nome: "Alarme", detalhe: "Bipes alternados, alto e insistente",
    tocar: (c, s, t) => {
      for (let i = 0; i < 8; i++) tom(c, s, i % 2 === 0 ? 1046 : 784, t + i * 0.3, 0.22, { tipo: "square", vol: 0.45, ataque: 0.01, sustentar: true });
    },
  },
  {
    id: "sirene", nome: "Sirene", detalhe: "Sobe e desce, impossível não ouvir",
    tocar: (c, s, t) => {
      for (let i = 0; i < 3; i++) {
        tom(c, s, 650, t + i * 0.7, 0.35, { tipo: "sawtooth", vol: 0.22, freqFim: 1300, sustentar: true });
        tom(c, s, 1300, t + i * 0.7 + 0.35, 0.35, { tipo: "sawtooth", vol: 0.22, freqFim: 650, sustentar: true });
      }
    },
  },
  {
    id: "despertador", nome: "Despertador", detalhe: "Rajadas rápidas de bipes",
    tocar: (c, s, t) => {
      for (let g = 0; g < 3; g++) for (let i = 0; i < 4; i++) {
        tom(c, s, 2000, t + g * 0.6 + i * 0.08, 0.05, { tipo: "square", vol: 0.25, sustentar: true });
      }
    },
  },
  {
    id: "campainha", nome: "Campainha", detalhe: "Ding-dong de porta, chegou alguém",
    tocar: (c, s, t) => {
      tom(c, s, 659.25, t, 0.6, { vol: 0.45 }); tom(c, s, 659.25 * 3, t, 0.25, { vol: 0.06 });
      tom(c, s, 523.25, t + 0.45, 0.9, { vol: 0.45 }); tom(c, s, 523.25 * 3, t + 0.45, 0.3, { vol: 0.06 });
    },
  },
  {
    id: "moeda", nome: "Moeda", detalhe: "Plim de moeda, ótimo para venda",
    tocar: (c, s, t) => { tom(c, s, 988, t, 0.09, { tipo: "square", vol: 0.2, sustentar: true }); tom(c, s, 1319, t + 0.09, 0.45, { tipo: "square", vol: 0.2 }); },
  },
  {
    id: "fanfarra", nome: "Fanfarra", detalhe: "Comemoração curta",
    tocar: (c, s, t) => {
      [[523.25, 0, 0.12], [659.25, 0.12, 0.12], [783.99, 0.24, 0.12], [1046.5, 0.36, 0.6]].forEach(([f, d, dur]) => {
        tom(c, s, f, t + d, dur, { tipo: "triangle", vol: 0.38 });
        tom(c, s, f * 2, t + d, dur, { tipo: "sine", vol: 0.08 });
      });
    },
  },
  {
    id: "atencao", nome: "Atenção", detalhe: "Grave-agudo duas vezes, sério",
    tocar: (c, s, t) => {
      [0, 0.5].forEach((d) => { tom(c, s, 440, t + d, 0.18, { tipo: "triangle", vol: 0.45, sustentar: true }); tom(c, s, 880, t + d + 0.2, 0.22, { tipo: "triangle", vol: 0.45, sustentar: true }); });
    },
  },
  {
    id: "suave", nome: "Suave", detalhe: "Nota única bem baixinha",
    tocar: (c, s, t) => { tom(c, s, 1046.5, t, 0.5, { vol: 0.18, ataque: 0.02 }); },
  },
  { id: "nenhum", nome: "Sem som", detalhe: "Não toca nada", tocar: () => {} },
];

// Eventos do sistema que tocam som, em grupos. "quem" = quem ouve.
export const GRUPOS_SONS = [
  { id: "clientes", nome: "Clientes e mensagens" },
  { id: "equipe", nome: "Equipe e I.A" },
  { id: "alertas", nome: "Alertas e vendas" },
  { id: "conexoes", nome: "Conexões do WhatsApp" },
  { id: "voce", nome: "Suas ações" },
];

export const EVENTOS = [
  {
    id: "novoCliente", grupo: "clientes", quem: "Admin",
    nome: "Cliente novo chegou",
    detalhe: "Primeira mensagem de um cliente que acabou de entrar (normalmente com a I.A).",
    padrao: "campainha", volume: 70,
  },
  {
    id: "mensagem", grupo: "clientes", quem: "Todos",
    nome: "Mensagem de um cliente seu",
    detalhe: "Cliente que está com você mandou mensagem.",
    padrao: "bolha", volume: 70,
  },
  {
    id: "monitor", grupo: "clientes", quem: "Admin",
    nome: "Mensagem em conversa de outro",
    detalhe: "Cliente falando com a I.A ou com outro atendente (só para acompanhar).",
    padrao: "gota", volume: 40,
  },
  {
    id: "transferencia", grupo: "equipe", quem: "Todos",
    nome: "Cliente transferido para você",
    detalhe: "Alarme que repete a cada 20s até você abrir o atendimento.",
    padrao: "alarme", volume: 90,
  },
  {
    id: "precisaHumano", grupo: "equipe", quem: "Admin",
    nome: "I.A pediu um humano",
    detalhe: "A I.A parou e o cliente está esperando alguém assumir.",
    padrao: "atencao", volume: 80,
  },
  {
    id: "avisoIA", grupo: "equipe", quem: "Admin",
    nome: "Outros avisos da I.A",
    detalhe: "Avisos gerais da assistente que não precisam de ação na hora.",
    padrao: "ding", volume: 60,
  },
  {
    id: "comunicado", grupo: "equipe", quem: "Todos",
    nome: "Comunicado da equipe",
    detalhe: "Admin ou supervisor deixou um recado num cliente seu.",
    padrao: "cristal", volume: 70,
  },
  {
    id: "venda", grupo: "alertas", quem: "Todos",
    nome: "Venda ou proposta finalizada",
    detalhe: "Uma venda foi registrada ou a I.A finalizou uma proposta.",
    padrao: "moeda", volume: 70,
  },
  {
    id: "problema", grupo: "alertas", quem: "Admin",
    nome: "Problema no sistema",
    detalhe: "Um atendente recusou um cliente ou outro problema geral.",
    padrao: "sirene", volume: 70,
  },
  {
    id: "conexaoCaiu", grupo: "conexoes", quem: "Admin",
    nome: "Número desconectado",
    detalhe: "Uma conexão do WhatsApp caiu e não voltou sozinha (ou precisa de QR Code).",
    padrao: "sirene", volume: 70,
  },
  {
    id: "conexaoVoltou", grupo: "conexoes", quem: "Admin",
    nome: "Número conectado novamente",
    detalhe: "Uma conexão que tinha caído voltou a funcionar.",
    padrao: "marimba", volume: 70,
  },
  {
    id: "envio", grupo: "voce", quem: "Todos",
    nome: "Você enviou uma mensagem",
    detalhe: "Estalo curto ao clicar em enviar, para confirmar que saiu.",
    padrao: "pop", volume: 50,
  },
];

export const configPadraoSons = () =>
  EVENTOS.reduce((acc, e) => ({ ...acc, [e.id]: { som: e.padrao, volume: e.volume } }), {});

let config = configPadraoSons();

// Aceita o valor da Setting (texto JSON) ou o objeto ja pronto.
export const aplicarConfigSons = (valor) => {
  try {
    const obj = typeof valor === "string" ? JSON.parse(valor || "{}") : valor || {};
    const base = configPadraoSons();
    EVENTOS.forEach((e) => {
      const v = obj[e.id] || {};
      base[e.id] = {
        som:
          SONS.some((s) => s.id === v.som) || String(v.som || "").startsWith("arquivo:")
            ? v.som
            : e.padrao,
        volume: Number.isFinite(Number(v.volume)) ? Math.max(0, Math.min(100, Number(v.volume))) : e.volume,
      };
    });
    config = base;
  } catch (e) {
    config = configPadraoSons();
  }
  return config;
};

export const configAtualSons = () => config;

export const carregarConfigSons = async () => {
  try {
    // _ = evita que o navegador devolva uma copia antiga guardada em cache
    const { data } = await api.get("/public-settings/sonsNotificacao", {
      params: { _: Date.now() },
    });
    if (data?.value) aplicarConfigSons(data.value);
  } catch (e) {
    /* sem configuracao salva: fica o padrao */
  }
  return config;
};

// ---------- audios proprios (MP3 etc. enviados em Configuracoes) ----------
// Toca no maximo 10s: musica inteira como aviso atrapalha o atendimento.
const DURACAO_MAX_ARQUIVO_MS = 10 * 1000;
let previaAtual = null;

const urlDoArquivo = (somId) =>
  `${getBackendUrl()}public/sons/${encodeURIComponent(String(somId).replace(/^arquivo:/, ""))}`;

const tocarArquivo = (somId, volume, aoFalhar) => {
  try {
    if (previaAtual) {
      previaAtual.pause();
      previaAtual = null;
    }
    const audio = new Audio(urlDoArquivo(somId));
    audio.volume = Math.max(0, Math.min(1, volume / 100));
    previaAtual = audio;
    const parar = setTimeout(() => audio.pause(), DURACAO_MAX_ARQUIVO_MS);
    audio.addEventListener("ended", () => clearTimeout(parar));
    // arquivo apagado ou que o navegador nao toca: usa o som padrao do evento
    audio.addEventListener("error", () => { clearTimeout(parar); if (aoFalhar) aoFalhar(); });
    const p = audio.play();
    if (p && p.catch) p.catch(() => {});
  } catch (e) {
    if (aoFalhar) aoFalhar();
  }
};

// Lista dos audios proprios (para os menus de Configuracoes).
export const listarSonsPersonalizados = async () => {
  try {
    const { data } = await api.get("/sons-personalizados", { params: { _: Date.now() } });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
};

export const pararPrevia = () => {
  if (previaAtual) {
    previaAtual.pause();
    previaAtual = null;
  }
};

const tocarSomId = (somId, volume, aoFalhar) => {
  if (String(somId || "").startsWith("arquivo:")) {
    if (volume) tocarArquivo(somId, volume, aoFalhar);
    return;
  }
  try {
    const som = SONS.find((s) => s.id === somId);
    if (!som || som.id === "nenhum" || !volume) return;
    const ctx = getCtx();
    const mestre = ctx.createGain();
    mestre.gain.value = (volume / 100) * 1.1;
    mestre.connect(ctx.destination);
    som.tocar(ctx, mestre, ctx.currentTime + 0.02);
  } catch (e) {}
};

// Toca o som configurado para o evento.
export const tocarSom = (evento) => {
  const c = config[evento];
  if (!c) return;
  const padrao = (EVENTOS.find((e) => e.id === evento) || {}).padrao;
  tocarSomId(c.som, c.volume, () => tocarSomId(padrao, c.volume));
};

// Previa na tela de Configuracoes (som e volume escolhidos, sem salvar).
export const tocarPrevia = (somId, volume = 70) => tocarSomId(somId, volume);

// Nomes antigos, usados pelo resto do sistema.
export const playReceiveMessageSound = () => tocarSom("mensagem");
export const playTransferSound = () => tocarSom("avisoIA");
export const playAlarmeTransferencia = () => tocarSom("transferencia");
export const playSendMessageSound = () => tocarSom("envio");
